export enum AuthRoutes {
    MAIN = "/auth",
    LOGIN = "/auth/login",
    REGISTER = "/auth/register",
    SUCCESSFUL_REGISTER = "/auth/successful-register",
    VERIFY_EMAIL = "/auth/verify-email",
    RECOVER_PASSWORD = "/auth/recover-password",
}
